<mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
  <span class="font-size-16 font-weight-400">
    {{ 'MAINTENANCES_REPORT.FILTERS.TITLE' | translate }}
  </span>
</mat-toolbar>

<form class="filter-content" [formGroup]="filtersForm" fusePerfectScrollbar *ngIf="filtersForm">
  <div class="filter-subtitle" [translate]="'MAINTENANCES_REPORT.FILTERS.PERIOD_CREATE'">Filter by period</div>

  <mat-list>
    <mat-list-item>
      <table width="100%">
        <tr>
          <td width="15%">
            <label class="filter-date-label" [translate]="'MAINTENANCES_REPORT.FILTERS.FROM'"> From: </label>
          </td>
          <td width="85%">
            <button mat-icon-button (click)="openedAtGte.open()">
              <i class="angularjs-fuse-icon icon-calendar-today"></i>
            </button>
            <mat-form-field appearance="standard" class="datepicker">
              <input
                placeholder="{{ 'MAINTENANCES_REPORT.FILTERS.OPENED_DATE' | translate }}"
                matInput
                [matDatepicker]="openedAtGte"
                [max]="filtersForm.get('openedAtLte').value"
                formControlName="openedAtGte"
              />
              <mat-datepicker-toggle matSuffix [for]="openedAtGte">
                <mat-icon aria-hidden="false" matDatepickerToggleIcon>arrow_drop_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #openedAtGte></mat-datepicker>

              <mat-error *ngIf="filtersForm.get('openedAtGte').hasError('invalidDate')">
                {{ 'MAINTENANCES_REPORT.FILTERS.INVALID_DATE' | translate }}
              </mat-error>
              <mat-error *ngIf="filtersForm.get('openedAtGte').hasError('invalidPeriod')">
                {{ 'MAINTENANCES_REPORT.FILTERS.INVALID_PERIOD' | translate }}
              </mat-error>
            </mat-form-field>
          </td>
        </tr>
      </table>
    </mat-list-item>
    <mat-list-item>
      <table width="100%">
        <tr>
          <td width="15%">
            <label class="filter-date-label" [translate]="'MAINTENANCES_REPORT.FILTERS.UNTIL'"> Until: </label>
          </td>
          <td width="85%">
            <button mat-icon-button (click)="openedAtLte.open()">
              <i class="angularjs-fuse-icon icon-calendar-today"></i>
            </button>
            <mat-form-field appearance="standard" class="datepicker">
              <input
                placeholder="{{ 'MAINTENANCES_REPORT.FILTERS.OPENED_DATE' | translate }}"
                matInput
                [matDatepicker]="openedAtLte"
                [min]="filtersForm.get('openedAtGte').value"
                formControlName="openedAtLte"
              />
              <mat-datepicker-toggle matSuffix [for]="openedAtLte">
                <mat-icon aria-hidden="false" matDatepickerToggleIcon>arrow_drop_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #openedAtLte></mat-datepicker>

              <mat-error *ngIf="filtersForm.get('openedAtLte').hasError('invalidDate')">
                {{ 'MAINTENANCES_REPORT.FILTERS.INVALID_DATE' | translate }}
              </mat-error>
              <mat-error *ngIf="filtersForm.get('openedAtLte').hasError('invalidPeriod')">
                {{ 'MAINTENANCES_REPORT.FILTERS.INVALID_PERIOD' | translate }}
              </mat-error>
            </mat-form-field>
          </td>
        </tr>
      </table>
    </mat-list-item>
  </mat-list>

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16" [translate]="'MAINTENANCES.FILTERS.PERIOD_SCHEDULED'">Filter by period</div>

  <mat-list>
    <mat-list-item>
      <table width="100%">
        <tr>
          <td width="15%">
            <label class="filter-date-label" [translate]="'MAINTENANCES.FILTERS.FROM'"> From: </label>
          </td>
          <td width="85%">
            <button mat-icon-button (click)="scheduledAtGte.open()">
              <i class="angularjs-fuse-icon icon-calendar-today"></i>
            </button>
            <mat-form-field appearance="standard" class="datepicker">
              <input
                placeholder="{{ 'MAINTENANCES.SCHEDULED_DATE' | translate }}"
                matInput
                [max]="filtersForm.get('scheduledAtLte').value"
                [matDatepicker]="scheduledAtGte"
                formControlName="scheduledAtGte"
              />
              <mat-datepicker-toggle matSuffix [for]="scheduledAtGte">
                <mat-icon aria-hidden="false" matDatepickerToggleIcon>arrow_drop_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #scheduledAtGte></mat-datepicker>

              <mat-error *ngIf="filtersForm.get('scheduledAtGte').hasError('invalidDate')">
                {{ 'MAINTENANCES_REPORT.FILTERS.INVALID_DATE' | translate }}
              </mat-error>
              <mat-error *ngIf="filtersForm.get('scheduledAtGte').hasError('invalidPeriod')">
                {{ 'MAINTENANCES_REPORT.FILTERS.INVALID_PERIOD' | translate }}
              </mat-error>
            </mat-form-field>
          </td>
        </tr>
      </table>
    </mat-list-item>

    <mat-list-item>
      <table width="100%">
        <tr>
          <td width="15%">
            <label class="filter-date-label" [translate]="'MAINTENANCES.FILTERS.UNTIL'"> Until: </label>
          </td>
          <td width="85%">
            <button mat-icon-button (click)="scheduledAtLte.open()">
              <i class="angularjs-fuse-icon icon-calendar-today"></i>
            </button>
            <mat-form-field appearance="standard" class="datepicker">
              <input
                placeholder="{{ 'MAINTENANCES.SCHEDULED_DATE' | translate }}"
                matInput
                [min]="filtersForm.get('scheduledAtGte').value"
                [matDatepicker]="scheduledAtLte"
                formControlName="scheduledAtLte"
              />
              <mat-datepicker-toggle matSuffix [for]="scheduledAtLte">
                <mat-icon aria-hidden="false" matDatepickerToggleIcon>arrow_drop_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #scheduledAtLte></mat-datepicker>

              <mat-error *ngIf="filtersForm.get('scheduledAtLte').hasError('invalidDate')">
                {{ 'MAINTENANCES_REPORT.FILTERS.INVALID_DATE' | translate }}
              </mat-error>
              <mat-error *ngIf="filtersForm.get('scheduledAtLte').hasError('invalidPeriod')">
                {{ 'MAINTENANCES_REPORT.FILTERS.INVALID_PERIOD' | translate }}
              </mat-error>
            </mat-form-field>
          </td>
        </tr>
      </table>
    </mat-list-item>
  </mat-list>

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16" [translate]="'MAINTENANCES.FILTERS.PERIOD_CLOSED'">Filter by period</div>

  <mat-list>
    <mat-list-item>
      <table width="100%">
        <tr>
          <td width="15%">
            <label class="filter-date-label" [translate]="'MAINTENANCES.FILTERS.FROM'"> From: </label>
          </td>
          <td width="85%">
            <button mat-icon-button (click)="closedAtGte.open()">
              <i class="angularjs-fuse-icon icon-calendar-today"></i>
            </button>
            <mat-form-field appearance="standard" class="datepicker">
              <input
                placeholder="{{ 'MAINTENANCES.CLOSED_DATE' | translate }}"
                matInput
                [max]="filtersForm.get('closedAtLte').value"
                [matDatepicker]="closedAtGte"
                formControlName="closedAtGte"
              />
              <mat-datepicker-toggle matSuffix [for]="closedAtGte">
                <mat-icon aria-hidden="false" matDatepickerToggleIcon>arrow_drop_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #closedAtGte></mat-datepicker>

              <mat-error *ngIf="filtersForm.get('closedAtGte').hasError('invalidDate')">
                {{ 'MAINTENANCES_REPORT.FILTERS.INVALID_DATE' | translate }}
              </mat-error>
              <mat-error *ngIf="filtersForm.get('closedAtGte').hasError('invalidPeriod')">
                {{ 'MAINTENANCES_REPORT.FILTERS.INVALID_PERIOD' | translate }}
              </mat-error>
            </mat-form-field>
          </td>
        </tr>
      </table>
    </mat-list-item>

    <mat-list-item>
      <table width="100%">
        <tr>
          <td width="15%">
            <label class="filter-date-label" [translate]="'MAINTENANCES.FILTERS.UNTIL'"> Until: </label>
          </td>
          <td width="85%">
            <button mat-icon-button (click)="closedAtLte.open()">
              <i class="angularjs-fuse-icon icon-calendar-today"></i>
            </button>
            <mat-form-field appearance="standard" class="datepicker">
              <input
                placeholder="{{ 'MAINTENANCES.CLOSED_DATE' | translate }}"
                matInput
                [min]="filtersForm.get('closedAtGte').value"
                [matDatepicker]="closedAtLte"
                formControlName="closedAtLte"
              />
              <mat-datepicker-toggle matSuffix [for]="closedAtLte">
                <mat-icon aria-hidden="false" matDatepickerToggleIcon>arrow_drop_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #closedAtLte></mat-datepicker>

              <mat-error *ngIf="filtersForm.get('closedAtLte').hasError('invalidDate')">
                {{ 'MAINTENANCES_REPORT.FILTERS.INVALID_DATE' | translate }}
              </mat-error>
              <mat-error *ngIf="filtersForm.get('closedAtLte').hasError('invalidPeriod')">
                {{ 'MAINTENANCES_REPORT.FILTERS.INVALID_PERIOD' | translate }}
              </mat-error>
            </mat-form-field>
          </td>
        </tr>
      </table>
    </mat-list-item>
  </mat-list>

  <mat-divider class="mt-16"></mat-divider>

  <location-legacy class="mt-16" formControlName="locationId"></location-legacy>

  <mat-divider class="mt-16"></mat-divider>

  <mat-form-field class="mt-16 w-100-p" appearance="legacy">
    <mat-label for="companies">{{ 'MAINTENANCES.COMPANY_PLACEHOLDER' | translate }}</mat-label>
    <mat-select formControlName="companies" multiple>
      <mat-select-trigger>
        {{
          filtersForm.get('companies').value && filtersForm.get('companies').value.length
            ? getPropertyValue(filtersForm.get('companies').value[0], companies, 'name')
            : ''
        }}
        <span *ngIf="filtersForm.get('companies').value?.length > 1">
          (+{{ filtersForm.get('companies').value.length - 1 }}
          {{
            filtersForm.get('companies').value.length === 2
              ? ('MAINTENANCES.COMPANY' | translate)
              : ('MAINTENANCES.COMPANIES' | translate)
          }})
        </span>
      </mat-select-trigger>
      <mat-option *ngFor="let company of companies; let $index = index" [value]="company.id">
        {{ company.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16">
    {{ 'MAINTENANCES_REPORT.FILTERS.MAINTENANCES_TYPE' | translate }}
  </div>

  <div class="filter-checkbox mt-16" formArrayName="maintenanceTypes">
    <mat-checkbox
      *ngFor="let maintenanceType of maintenanceTypes; let $index = index"
      labelPosition="before"
      [formControlName]="$index"
    >
      {{ maintenanceType.name }}
    </mat-checkbox>
  </div>

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16" [translate]="'MAINTENANCES_REPORT.FILTERS.LOCATIONS_GROUPS'">Location groups</div>

  <div class="filter-checkbox mt-16" formArrayName="locationsGroups">
    <mat-checkbox
      *ngFor="let locationGroup of locationsGroups; let $index = index"
      labelPosition="before"
      [formControlName]="$index"
    >
      {{ locationsGroups[$index].name }}
    </mat-checkbox>
  </div>

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16" [translate]="'MAINTENANCES_REPORT.FILTERS.SEGMENTS'">Segments</div>

  <div class="filter-checkbox mt-16" formArrayName="segments">
    <mat-checkbox
      *ngFor="let segment of segments; let $index = index"
      labelPosition="before"
      [formControlName]="$index"
    >
      {{ segments[$index].name }}
    </mat-checkbox>
  </div>

  <mat-divider class="mt-16 mb-52"></mat-divider>
</form>
